import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { GrievanceNotificationStatusEnum } from 'src/app/shared/enum/hospital-document/grievance-notification-status.enum';
import { GrievanceNotificationDetailsRequest } from 'src/app/shared/services/requests/hospital-document/grievance-notification-details.request';

@Component({
    selector: 'app-grievance-notification-modal',
    templateUrl: './grievance-notification-modal.component.html',
    styleUrls: ['./grievance-notification-modal.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class GrievanceNotificationModalComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public matDialogRef: MatDialogRef<GrievanceNotificationModalComponent>,
  ) {
    this.matDialogRef.disableClose = true;
  }
  public confirm: boolean = false;
  public isMandatoryComletion: boolean = false;
  public request: GrievanceNotificationDetailsRequest;

  ngOnInit(): void {
    this.isMandatoryComletion = this.data.isMandatoryComletion;
    this.mapToDefaultAIHStruct();
  }

  clickConfirm() {
    this.matDialogRef.close({ isGrivanceNotificationRedirect: true, request: this.request });
    return;
  }

  clickCancel() {
    this.matDialogRef.close({ isGrivanceNotificationRedirect: false, request: this.request });
  }

  mapToDefaultAIHStruct() {
    this.request = new GrievanceNotificationDetailsRequest();
    this.request.idGrievanceNotificationStatus = GrievanceNotificationStatusEnum.pendente;
    this.request.idGrievanceNotification = this.data.idGrievanceNotification;
    this.request.idEpisode = this.data.idEpisode;
    this.request.idUser = this.data.idUser;
    this.request.idTriage = this.data.idTriage;
  }
}
